export default __webpack_public_path__ + "static/media/Wahida-Bano-Madna.fb866565.jpg";